import {API} from "../../constAPI";

export const LoginAdmin = (post) => {
  return fetch(`${API}/api/auth/login`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-type": "application/json",
    },
    body: JSON.stringify(post),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const authenticate = (data, next) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("user", JSON.stringify(data));
    next();
  }
};

export const isAuthenticated = () => {
  if (localStorage.getItem("user")) {
    return JSON.parse(localStorage.getItem("user"));
  }
  return false;
};

export const signout = (next) => {
  if (localStorage.getItem("user")) {
    localStorage.removeItem("user");
  }
  next();
};
